// Curated list of product types for custom order items
// To add new types in the future, simply add to this array
export const PRODUCT_TYPES = [
  'Fresh Arrangement',
  'Bouquet',
  'Boutonniere',
  'Wrap',
  'Corsage',
  'Plant',
];

export const DEFAULT_PRODUCT_TYPE = 'Fresh Arrangement';
